import React from 'react';

import Grid from '@material-ui/core/Grid';
import MoneyOffIcon from '@material-ui/icons/MoneyOff';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import { getDateTime } from '../helpers';
import { getMoney } from '../helpers';
import { getValue } from '../helpers';
import { PAGE_MENU, PAGINATION, STYLES } from '../../constants';
import API from '../../services/api';
import ButtonSort from '../custom/buttonsort';
import CustomAlert from '../custom/alert';
import CustomPaper from '../custom/paper';
import CustomPopover from '../custom/popover';
import CustomTablePagination from '../custom/tablepagination';
import FilterLogDialog from '../filterlogdialog';
import Title from '../title';

export default function ComponentSaquelog({ children, ...props }) {
  const load = React.useRef(true);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [row, setRow] = React.useState(null);

  const [alert, setAlert] = React.useState({ open: false, message: '' });
  const [pagination, setPagination] = React.useState({ perPage: PAGINATION.PER_PAGE });
  const [query, setQuery] = React.useState(null);
  const [reload, setReload] = React.useState(false);
  const [sortConfig, setSortConfig] = React.useState({ asc: true, id: '', keys: [] });
  const [state, setState] = React.useState({ data: [], lastPage: 1, page: 1, perPage: 20, total: 0 });

  function componentDidMount() {
    if (load.current) {
      API.Saques.index({ ...pagination, ...query }).then(onSuccess).catch(onFailure);
    }
    return function componentWillUnmount() { load.current = false; };
  }

  function onPaginationChanged() {
    API.Saques.index({ ...pagination, ...query }).then(onSuccess).catch(onFailure);
    return function paginationChanged() { };
  }

  function onReloadChanged() {
    if (reload) {
      API.Saques.index({ ...query, perPage: pagination.perPage, page: 1 }).then(onSuccess).catch(onFailure);
    }
    return function reloadChanged() { setReload(false); };
  }

  function onFilterChanged() {
    API.Saques.index({ ...query, perPage: pagination.perPage, page: 1 }).then(onSuccess).catch(onFailure);
    return function filterChanged() { };
  }

  React.useEffect(componentDidMount, []);
  React.useEffect(onPaginationChanged, [pagination]);
  React.useEffect(onReloadChanged, [reload]);
  React.useEffect(onFilterChanged, [query]);

  function onSuccess(response) {
    if (load.current && response.data) {
      setState(response.data);
    }
  }

  function onFailure(error) {
    if (load.current && error) {
      setAlert({ open: true, message: error.message });
    }
  }

  function handleChangePagination(newPagination) {
    setPagination({ ...pagination, ...newPagination });
  }

  const handlePopoverOpen = (event, item) => {
    setAnchorEl(event.currentTarget);
    setRow(item);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
    setRow(null);
  };

  return (
    <>
      <FilterLogDialog
        title={'Filtrar saques'}
        setFilter={setQuery}
        filter={query}
        show_from_account={true}
        show_owner_email={true}
        show_owner_name={true}
      />

      <CustomPopover
        open={Boolean(anchorEl)}
        item={anchorEl}
        onClose={handlePopoverClose}
        data={row}
      >
      </CustomPopover>

      <CustomPaper>
        <CustomAlert open={alert.open} onClose={() => setAlert({ ...alert, open: false })} >{alert.message}</CustomAlert>
        <Grid container spacing={1}>
          <Grid item >
            <Title><MoneyOffIcon /></Title>
          </Grid>
          <Grid item >
            <Title>{PAGE_MENU.SAQUES}</Title>
          </Grid>
        </Grid>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell align="inherit">
                <ButtonSort
                  id={'description'}
                  keys={['description']}
                  config={sortConfig}
                  setConfig={setSortConfig}
                  state={state}
                  setState={setState}
                >
                  {'Motivo'}
                </ButtonSort>
              </TableCell>
              <TableCell align="inherit">
                <ButtonSort
                  id={'owners_email'}
                  keys={['owners_email']}
                  config={sortConfig}
                  setConfig={setSortConfig}
                  state={state}
                  setState={setState}
                >
                  {'Responsável'}
                </ButtonSort>
              </TableCell>
              <TableCell align="inherit">
                <ButtonSort
                  id={'from_account_name'}
                  keys={['from_account.name']}
                  config={sortConfig}
                  setConfig={setSortConfig}
                  state={state}
                  setState={setState}
                >
                  {'Origem'}
                </ButtonSort>
              </TableCell>
              <TableCell align="inherit">
                <ButtonSort
                  id={'valor'}
                  keys={['valor']}
                  config={sortConfig}
                  setConfig={setSortConfig}
                  state={state}
                  setState={setState}
                >
                  {'Valor'}
                </ButtonSort>
              </TableCell>
              <TableCell align="inherit">
                <ButtonSort
                  id={'logtime'}
                  keys={['logtime']}
                  config={sortConfig}
                  setConfig={setSortConfig}
                  state={state}
                  setState={setState}
                >
                  {'Data e Hora'}
                </ButtonSort>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {state.data
              .map((item) => (
                <TableRow key={item.id}>
                  <TableCell align="inherit" onMouseEnter={(e) => handlePopoverOpen(e, item)} onMouseLeave={handlePopoverClose}>{getValue(item, 'description', '')}</TableCell>
                  <TableCell align="inherit" onMouseEnter={(e) => handlePopoverOpen(e, item)} onMouseLeave={handlePopoverClose}>{getValue(item, 'owners_email', '')}</TableCell>
                  <TableCell align="inherit" onMouseEnter={(e) => handlePopoverOpen(e, item)} onMouseLeave={handlePopoverClose}>{getValue(item, 'from_account.name', '')}</TableCell>
                  <TableCell align="inherit" style={STYLES.MONEY.NEGATIVE}>{getMoney(item, ['valor'], 0, '-')}</TableCell>
                  <TableCell align="inherit" >{getDateTime(item, 'logtime', '')}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
        <CustomTablePagination page={state.page - 1 | 0} count={state.total} onChange={handleChangePagination} />
      </CustomPaper >
    </>
  );
}
